// entities/modal/model/modal.store.ts
import { makeAutoObservable } from 'mobx';

export type ModalType =
  'example'
  | 'confirm'
  | 'privacyPolicy'
  | 'offer'
  | 'termsOfService'
  | 'newsletter'
  | 'notification'
  | 'contactModal'
  | 'changePassword'
  | 'testDetails'
  | null;

class ModalStore {
  isOpen = false;
  modalType: ModalType = null;
  modalProps: any = {};

  constructor() {
    makeAutoObservable(this);
  }

  openModal(type: ModalType, props: any = {}) {
    this.isOpen = true;
    this.modalType = type;
    this.modalProps = props;
  }

  closeModal() {
    this.isOpen = false;
    this.modalType = null;
    this.modalProps = {};
  }
}

export const modalStore = new ModalStore();
